module.exports = __webpack_public_path__ + "media/PAG67-04.a99169f7.mp3";